import React from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import {
  FullWidth,
  BannerContentContainer,
  BannerTextContainer,
} from "../styles/styled-components/bannerStyles"

const FeaturedBanner = ({ image, title, subtitle }) => {
  return (
    <FullWidth
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0, 0.7), rgba(0,0,0, 0.7)), url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`,
      }}
    >
      <BannerContentContainer>
        <BannerTextContainer>
          <FeaturedTitle className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen">
            {title}
          </FeaturedTitle>
          {subtitle ? (
            <FeaturedSubtitle className="has-text-weight-bold is-size-6-mobile is-size-5-tablet is-size-4-widescreen">
              {subtitle}
            </FeaturedSubtitle>
          ) : null}
        </BannerTextContainer>
      </BannerContentContainer>
    </FullWidth>
  )
}

FeaturedBanner.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

const FeaturedTitle = styled.h1`
  color: white;
  padding: 0.25em;
  text-shadow: 2px 2px #603f8b;
`

const FeaturedSubtitle = styled.h1`
  color: white;
  padding: 0.25em;
`

export default FeaturedBanner
